var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlower3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 505 486",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.974 137.735C356.246 149.364 327.827 168.543 305.171 193.614C322.015 164.262 331.382 131.218 332.448 97.3931C332.448 26.7724 253 0.289673 253 0.289673C253 0.289673 173.552 26.7724 173.552 97.3931C174.618 131.218 183.985 164.262 200.829 193.614C178.133 168.671 149.717 149.616 118.026 138.088C50.8482 115.931 1.14893 183.286 1.14893 183.286C1.14893 183.286 1.76685 267.059 68.9448 289.217C101.421 298.596 135.702 299.869 168.785 292.924C137.889 306.749 110.875 327.972 90.131 354.717C48.6413 411.832 97.3696 479.981 97.3696 479.981C97.3696 479.981 176.818 505.228 218.661 448.113C237.8 419.851 249.601 387.268 253 353.305C256.499 387.054 268.296 419.413 287.339 447.495C328.829 504.61 408.63 479.363 408.63 479.363C408.63 479.363 457.359 411.214 415.869 354.099C395.171 327.416 368.259 306.202 337.48 292.306C370.474 299.254 404.67 297.981 437.055 288.599C504.233 266.794 504.851 182.668 504.851 182.668C504.851 182.668 455.152 115.931 387.974 137.735Z",
    fill: "#F0C419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.3931C332.448 152.742 300.316 210.386 264.829 252.052C259.151 246.915 250.808 246.024 244.172 249.846C231.689 229.666 217.165 210.823 200.829 193.614C202.33 193.614 173.552 151.153 173.552 97.3931C173.552 26.7724 253 0.289673 253 0.289673C253 0.289673 332.448 26.7724 332.448 97.3931Z",
    fill: "#CC0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.3931C332.448 152.742 300.316 210.386 264.829 252.052C259.151 246.915 250.808 246.024 244.172 249.846C231.689 229.666 217.165 210.823 200.829 193.614C202.33 193.614 173.552 151.153 173.552 97.3931C173.552 26.7724 253 0.289673 253 0.289673C253 0.289673 332.448 26.7724 332.448 97.3931Z",
    fill: "url(#paint0_linear_1692_139462)",
    fillOpacity: 0.48
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253 256.29C248.125 256.29 244.172 252.337 244.172 247.462V141.531C244.172 136.656 248.125 132.703 253 132.703C257.875 132.703 261.828 136.656 261.828 141.531V247.462C261.828 252.337 257.875 256.29 253 256.29Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 268.825C212.332 274.351 189.964 282.281 168.608 292.483C135.467 299.379 101.148 298.137 68.5918 288.863C1.41383 267.059 0.795898 182.932 0.795898 182.932C0.795898 182.932 50.8483 115.931 118.026 137.735C170.992 154.861 215.13 202.883 244.172 249.846C237.393 253.558 233.816 261.248 235.345 268.825Z",
    fill: "#FF1919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 268.825C212.332 274.351 189.964 282.281 168.608 292.483C135.467 299.379 101.148 298.137 68.5918 288.863C1.41383 267.059 0.795898 182.932 0.795898 182.932C0.795898 182.932 50.8483 115.931 118.026 137.735C170.992 154.861 215.13 202.883 244.172 249.846C237.393 253.558 233.816 261.248 235.345 268.825Z",
    fill: "url(#paint1_linear_1692_139462)",
    fillOpacity: 0.48
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.228 268.472C234.197 268.472 241.877 270.855 132.768 235.28C128.314 233.64 125.954 228.77 127.427 224.258C128.899 219.745 133.677 217.205 138.241 218.508L238.964 251.258C243.08 252.611 245.606 256.751 244.926 261.03C244.246 265.309 240.56 268.462 236.228 268.472Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.305C249.501 387.054 237.704 419.413 218.661 447.495C177.171 504.61 97.3698 479.363 97.3698 479.363C97.3698 479.363 48.6415 411.214 90.1311 354.099C122.44 309.608 182.379 281.89 235.345 268.825C236.949 276.303 243.185 281.898 250.793 282.684C249.087 306.237 249.827 329.904 253 353.305Z",
    fill: "#F00000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.305C249.501 387.054 237.704 419.413 218.661 447.495C177.171 504.61 97.3698 479.363 97.3698 479.363C97.3698 479.363 48.6415 411.214 90.1311 354.099C122.44 309.608 182.379 281.89 235.345 268.825C236.949 276.303 243.185 281.898 250.793 282.684C249.087 306.237 249.827 329.904 253 353.305Z",
    fill: "url(#paint2_linear_1692_139462)",
    fillOpacity: 0.48
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.349 373.961C177.085 373.841 174.154 371.927 172.73 368.987C171.306 366.047 171.622 362.561 173.552 359.926L235.345 274.21C237.332 271.75 240.48 270.537 243.604 271.027C246.728 271.518 249.353 273.638 250.489 276.589C251.626 279.539 251.103 282.872 249.116 285.332L187.323 370.342C185.693 372.574 183.112 373.913 180.349 373.961Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.363C408.63 479.363 329.182 504.61 287.339 447.495C254.677 402.563 246.997 337.239 251.146 282.684C258.651 283.334 265.741 279.151 268.801 272.268C290.744 281.317 313.548 288.12 336.862 292.571C367.72 306.457 394.72 327.67 415.516 354.364C457.359 411.214 408.63 479.363 408.63 479.363Z",
    fill: "#FF1919"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.363C408.63 479.363 329.182 504.61 287.339 447.495C254.677 402.563 246.997 337.239 251.146 282.684C258.651 283.334 265.741 279.151 268.801 272.268C290.744 281.317 313.548 288.12 336.862 292.571C367.72 306.457 394.72 327.67 415.516 354.364C457.359 411.214 408.63 479.363 408.63 479.363Z",
    fill: "url(#paint3_linear_1692_139462)",
    fillOpacity: 0.48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.651 373.961C322.826 373.969 320.168 372.623 318.501 370.342L256.178 284.626C254.317 282.04 253.977 278.658 255.287 275.753C256.596 272.849 259.355 270.863 262.525 270.545C265.695 270.227 268.794 271.624 270.655 274.21L332.448 359.926C334.378 362.561 334.694 366.047 333.27 368.987C331.846 371.927 328.915 373.841 325.651 373.961Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 183.285C504.851 183.285 504.233 267.059 437.055 289.217C384.09 306.872 320.178 293.719 269.331 272.621C272.398 265.654 270.654 257.507 265.006 252.405C280.379 234.241 293.839 214.539 305.171 193.614C327.867 168.671 356.283 149.616 387.974 138.088C455.152 115.931 504.851 183.285 504.851 183.285Z",
    fill: "#F00000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 183.285C504.851 183.285 504.233 267.059 437.055 289.217C384.09 306.872 320.178 293.719 269.331 272.621C272.398 265.654 270.654 257.507 265.006 252.405C280.379 234.241 293.839 214.539 305.171 193.614C327.867 168.671 356.283 149.616 387.974 138.088C455.152 115.931 504.851 183.285 504.851 183.285Z",
    fill: "url(#paint4_linear_1692_139462)",
    fillOpacity: 0.48
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.772 268.472C265.44 268.462 261.754 265.309 261.074 261.03C260.394 256.751 262.92 252.611 267.036 251.258L367.759 218.508C372.323 217.205 377.101 219.745 378.573 224.258C380.046 228.77 377.686 233.64 373.232 235.28C264.034 270.855 271.891 268.472 269.772 268.472Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 264.971C280.013 278.077 270.613 289.299 257.708 291.584C244.803 293.869 232.121 286.555 227.635 274.242C223.148 261.928 228.153 248.17 239.503 241.617C247.852 236.797 258.137 236.794 266.489 241.61C274.84 246.426 279.99 255.33 280 264.971Z",
    fill: "#FF4949"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1692_139462",
    x1: 299.714,
    y1: 0.00362343,
    x2: 221.917,
    y2: 242.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1692_139462",
    x1: 244,
    y1: 215.579,
    x2: 19.128,
    y2: 279.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1692_139462",
    x1: 216,
    y1: 268.579,
    x2: 163.199,
    y2: 484.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1692_139462",
    x1: 394.912,
    y1: 272.026,
    x2: 344.382,
    y2: 485.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1692_139462",
    x1: 504.681,
    y1: 215.991,
    x2: 282.528,
    y2: 278.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower3);
export default __webpack_public_path__ + "static/media/flower3.6949ecb56309f2a21ff3fc79ca420cbb.svg";
export { ForwardRef as ReactComponent };